import React from 'react';

export default function ResponseReason({ status, note }) {
  if (status !== 'Denied' || !note?.trim()) return null;
  return <div style={{ fontSize: 14, whiteSpace: 'pre-wrap', overflowWrap: 'anywhere', marginTop: 4 }}>
    <strong>Reason:</strong> {note}
  </div>;
}
